import React from 'react';
import './courseKit.css';

/**
 * Payment plan chooser. Renders EVERY plan the catalog returns, including the
 * five-payment option, and always shows both the per-payment amount and the
 * total obligation so an installment plan can never look cheaper than it is.
 *
 * All amounts come from the server (product_plan + promotions). Nothing here
 * computes or hardcodes a price.
 */
const PlanSelector = ({ plans = [], selectedKey, onSelect }) => {
  if (!plans.length) return null;

  // Smallest payment first, the way infomercials price (Rob, 2026-09-13).
  const ordered = [...plans].sort((a, b) => (b.installments || 1) - (a.installments || 1));

  return (
    <div className="ck-plans" role="radiogroup" aria-label="Payment options">
      {ordered.map((plan) => {
        const selected = plan.planKey === selectedKey;
        const isInstallment = plan.installments > 1;
        return (
          <button
            key={plan.planKey}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`ck-plan ${selected ? 'is-selected' : ''}`.trim()}
            onClick={() => onSelect?.(plan.planKey)}
          >
            <span className="ck-plan-head">
              <span className="ck-plan-name">
                {isInstallment ? `${plan.installments} monthly payments` : 'Pay in full'}
              </span>
              {plan.hasDiscount && plan.originalDisplay ? (
                <span className="ck-plan-was">
                  {plan.originalDisplay}
                  {isInstallment ? '/mo' : ''}
                </span>
              ) : null}
            </span>

            <span className="ck-plan-amount">
              {plan.display}
              {isInstallment ? <em>/mo</em> : null}
            </span>

            <span className="ck-plan-total">
              {isInstallment ? `${plan.totalDisplay} total` : 'One payment'}
            </span>

            {plan.hasDiscount && plan.savingsDisplay ? (
              <span className="ck-plan-save">Save {plan.savingsDisplay} vs full price</span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
};

export default PlanSelector;
